export const categoryColumns = [
  { field: "title", header: "Category Name" },
  { field: "description", header: "Description" },
  { field: "created_at", header: "Date Created" },
  // { header: "Action(s)" },
];

export const assetColumns = [
  { field: "title", header: "Asset Name" },
  { field: "code", header: "Asset Code" },
  { field: "serial_number", header: "Serial No." },
  { field: "make", header: "Asset Make" },
  { field: "model", header: "Asset Model" },
  // { header: "Action(s)" },
];

export const locationColumns = [
  { field: "title", header: "Branches Name" },
  { field: "phone", header: "Contact" },
  { field: "street_address", header: "Street Address" },

  { field: "digital_address", header: "Digital Address" },
  // { header: "Action(s)" },
];

export const inventoryColumns = [
  { field: "title", header: "Inventory Name" },
  { field: "description", header: "Description" },
  { header: "Manager" },
  // { header: "Action(s)" },
];
